function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
var Timer = function () {
    function Timer(player) {
        _classCallCheck(this, Timer);
        this.player = player;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        this.types = [
            'loading',
            'info',
            'fps',
            'download'
        ];
        this.init();
    }
    _createClass(Timer, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.types.map(function (item) {
                    if (item !== 'fps') {
                        _this['init'.concat(item, 'Checker')]();
                    }
                    return item;
                });
            }
        },
        {
            key: 'initloadingChecker',
            value: function initloadingChecker() {
                var _this2 = this;
                var lastPlayPos = 0;
                var currentPlayPos = 0;
                var bufferingDetected = false;
                this.loadingChecker = setInterval(function () {
                    if (_this2.enableloadingChecker && !_this2.player.video.paused) {
                        currentPlayPos = _this2.player.video.currentTime;
                        if (!bufferingDetected && currentPlayPos === lastPlayPos) {
                            _this2.enabledownloadChecker = utils.isChrome;
                            _this2.player.template.loading.classList.add('show');
                            _this2.player.container.classList.add('mfunsPlayer-loading');
                            _this2.player.danmaku && _this2.player.danmaku.pause();
                            bufferingDetected = true;
                        }
                        if (bufferingDetected && currentPlayPos > lastPlayPos) {
                            _this2.enabledownloadChecker = false;
                            _this2.player.template.loading.classList.remove('show');
                            _this2.player.container.classList.remove('mfunsPlayer-loading');
                            _this2.player.danmaku && _this2.player.danmaku.play();
                            bufferingDetected = false;
                        }
                        lastPlayPos = currentPlayPos;
                    }
                }, 100);
            }
        },
        {
            key: 'initfpsChecker',
            value: function initfpsChecker() {
                var _this3 = this;
                window.requestAnimationFrame(function () {
                    if (_this3.enablefpsChecker) {
                        _this3.initfpsChecker();
                        if (!_this3.fpsStart) {
                            _this3.fpsStart = new Date();
                            _this3.fpsIndex = 0;
                        } else {
                            _this3.fpsIndex++;
                            var fpsCurrent = new Date();
                            if (fpsCurrent - _this3.fpsStart > 1000) {
                                _this3.player.infoPanel.fps(_this3.fpsIndex / (fpsCurrent - _this3.fpsStart) * 1000);
                                _this3.fpsStart = new Date();
                                _this3.fpsIndex = 0;
                            }
                        }
                    } else {
                        _this3.fpsStart = 0;
                        _this3.fpsIndex = 0;
                    }
                });
            }
        },
        {
            key: 'initinfoChecker',
            value: function initinfoChecker() {
                var _this4 = this;
                this.infoChecker = setInterval(function () {
                    if (_this4.enableinfoChecker) {
                        _this4.player.infoPanel.update();
                    }
                }, 1000);
            }
        },
        {
            key: 'initdownloadChecker',
            value: function initdownloadChecker() {
                var _this5 = this;
                var lastPlayerLoaded = 0;
                var currentPlayerLoaded = 0;
                this.downloadChecker = setInterval(function () {
                    if (_this5.enabledownloadChecker) {
                        var _this5$player$video = _this5.player.video, videoLoaded = _this5$player$video.webkitVideoDecodedByteCount, audioLoaded = _this5$player$video.webkitAudioDecodedByteCount;
                        currentPlayerLoaded = videoLoaded + audioLoaded;
                        var downlaodSpeed = parseInt(Math.max(currentPlayerLoaded - lastPlayerLoaded, 0) / 1024);
                        _this5.player.template.loadingSpeed.innerHTML = ''.concat(downlaodSpeed > 1000 ? (downlaodSpeed / 1024).toFixed(2) + 'MB/s' : downlaodSpeed + 'KB/s', ' ');
                        lastPlayerLoaded = currentPlayerLoaded;
                    }
                }, 500);
            }
        },
        {
            key: 'enable',
            value: function enable(type) {
                this['enable'.concat(type, 'Checker')] = true;
                if (type === 'fps') {
                    this.initfpsChecker();
                }
            }
        },
        {
            key: 'disable',
            value: function disable(type) {
                this['enable'.concat(type, 'Checker')] = false;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                var _this6 = this;
                this.types.map(function (item) {
                    _this6['enable'.concat(item, 'Checker')] = false;
                    _this6[''.concat(item, 'Checker')] && clearInterval(_this6[''.concat(item, 'Checker')]);
                    return item;
                });
            }
        }
    ]);
    return Timer;
}();
export default Timer;